import { FormattedMessage } from 'react-intl';

import { serviceOrderTypes } from '#domain/ServiceOrder.ts';

type Props = { value: string; category?: string };

export const ServiceTypeName = ({ value, category }: Props) => {
    const knownCategory = serviceOrderTypes.find(type => type === category);
    return knownCategory ? (
        <FormattedMessage
            id={`intl-msg:ordercom-cloud-frontend.service.type.${knownCategory}`}
            defaultMessage={knownCategory}
        />
    ) : (
        value
    );
};
